import * as React from 'react';
import { useField } from 'formik';
import Error from './Error';

export type TInputType = 'color' | 'text' | 'number' | 'password' | 'hidden' | 'email';

interface IInputProps {
  id: string;
  label: string;
  name: string;
  type: TInputType;
  placeholder?: string;
  readonly?: boolean;
  className?: string;
  required?: boolean;
}

const LoginInput: React.FC<IInputProps> = (props) => {
  const [field, meta] = useField(props);
  let errBorder = '';
  if (meta.touched && meta.error) {
    errBorder = 'err-border';
  }

  return (
    <div className={`m-0 mb-2 text-input-component ${errBorder ? 'has-error' : ''}`}>
      <div className="row">
        <label htmlFor={props.id} className="col-12 font-weight-bold mb-1">
          {props.label}
        </label>
        <div className="col-12">
          <input
            {...field}
            {...props}
            data-cy={`form-input-${props.name}`}
            type={props.type}
            placeholder={props.placeholder || ''}
            name={props.name}
            id={props.id}
            readOnly={props.readonly || false}
            className={`${props.className} form-control ${errBorder}`}
          />
          {meta.touched && meta.error && (
            <div>
              <div className="form-group-error">
                <Error message={meta.error} newStyle={true} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginInput;
